import httpClient from '../lib/httpClient';

const basePath = 'admin/orders';
const apiPath = 'api/orders';

// Generate or retrieve device UUID for uuid_local
export const getDeviceUUID = () => {
  let deviceUUID = localStorage.getItem('deviceUUID');
  if (!deviceUUID) {
    deviceUUID = crypto.randomUUID();
    localStorage.setItem('deviceUUID', deviceUUID);
  }
  return deviceUUID;
};

export const listOrders = (query) => httpClient.get(basePath, { query });
export const getOrder = (id) => httpClient.get(`${basePath}/${id}`);
export const createOrder = (payload) => httpClient.post(apiPath, payload);
export const syncOrders = (orders) => httpClient.post(`${basePath}/sync`, { orders });

const orderServiceExport = {
  listOrders,
  getOrder,
  createOrder,
  syncOrders
};

export default orderServiceExport;
